// extracted by mini-css-extract-plugin
export var alignCenter = "_a4-d";
export var bannerShown = "_a4-6";
export var buttonContent = "_a4-0";
export var cardList = "_a4-1";
export var centerContent = "_a4-2";
export var chevron = "_a4-3";
export var closePanelButton = "_a4-k";
export var conversationContextContainer = "_a4-l";
export var conversationDetailContainer = "_a4-4";
export var detailWrapper = "_a4-7";
export var dropdownButton = "_a4-e";
export var dropdownTitle = "_a4-9";
export var fullHeight = "_a4-5";
export var hidden = "_a4-a";
export var icon = "_a4-b";
export var mergeSuggestionWrapper = "_a4-m";
export var panel = "_a4-i";
export var portalButtonsWrapper = "_a4-c";
export var right = "_a4-j";
export var tableSummaryContainer = "_a4-8";
export var tableSummaryHeader = "_a4-g";
export var threeDotsButton = "_a4-f";
export var wide = "_a4-h";